/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Auth } from '../../../modules/auth/Auth';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import GridItem from '../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import GridContainer from 'components/Grid/GridContainer.jsx';
import Card from 'components/Card/Card.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import CardBody from '../../../components/Card/CardBody';
import ChangeButton from '../../../components/Buttons/CustomTextButton';
import TariffsRange from '../../../components/Adescom/SimpleSelectRest';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { SimCardEntity, SimCardStatus } from '../../../modules/simcard/Entity';
import IccidPoolChooseDialog from '../../iccid-pools/Dialog/IccidPoolChooseDialog';
import { simCardActions, simCardConstants } from '../../../modules/simcard/actions';
import { notificationConstants } from '../../../modules/notifications/notifications';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';

class SimCardChangeIccid extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            new_iccid: null,
            new_uri: null,
            entity: SimCardEntity,
            entityStatus: SimCardStatus,
            tariffs: null,
            showAccept: false,
            openIccid: false,
            simCard: this.props.item,
            iccidItem: null,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.tariffs && state.tariffs !== props.tariffs) {
            state.tariffs = props.tariffs;
        }
        return state;
    }

    openGetIccid = () => {
        this.setState((prevState) => ({
            openIccid: true,
        }));
    };

    closeIccid = () => {
        this.setState((prevState) => ({
            openIccid: false,
        }));
    };

    callBackSetIccid = (value) => {
        const { item } = this.props;
        this.setState(
            {
                entity: {
                    tariffId: item.tariffId,
                },
                showAccept: true,
                new_iccid: value.item.iccid,
                new_uri: value.item['@id'],
                iccidItem: value.item,
            },
            () => {
                this.closeIccid();
                this.reloadTariffList();
            }
        );
    };

    selectFunc = (e, stateName, require) => {
        FormGeneralHelper.selectFunc(this, e, stateName, require);
    };

    reloadTariffList() {
        const { dispatch } = this.props;
        dispatch(
            simCardActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/tariffs')),
                [{ name: 'indicatedRangeId', value: this.state.iccidItem.indicatedRangeId }],
                [{ name: 'mainname', value: 'asc' }],
                simCardConstants.SIM_CARD_TARIFF_ICCID
            )
        );
    }

    callChangeESIMButton = () => {
        const { simCard } = this.state;
        const { dispatch } = this.props;
        const itemLoader = new ItemLoaders(dispatch);
        const params = {
            activationType: 10,
            params: '{}',
            id: simCard.id,
        };
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
            'change-esim-continue',
            params,
            (data) => {
                dispatch({
                    ...this.state,
                    type: notificationConstants.CUSTOM_NOTIFY,
                    message: 'simcard:edit.wait_to_change_iccid',
                    variant: 'success',
                });
            },
            { propagateDataToCallback: true, dispatchErrorAfterCallback: false }
        );
    };

    callChangeButton = () => {
        const { dispatch } = this.props;
        if (this.state.new_iccid === null) {
            dispatch({
                ...this.state,
                type: notificationConstants.CUSTOM_NOTIFY,
                message: 'error:sim_card.empty_iccid_number',
                variant: 'error',
            });
            return;
        }
        const params = {
            iccid: this.state.new_iccid,
            simCardId: this.state.simCard.id,
            tariffId: this.state.entity.tariffId,
        };
        dispatch(
            simCardActions.post(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_change_iccids')),
                params,
                simCardConstants.SIM_CARD_CHANGE_MSISDN_REQUEST,
                () => {
                    dispatch({
                        ...this.state,
                        type: notificationConstants.CUSTOM_NOTIFY,
                        message: 'simcard:edit.wait_to_change_iccid',
                        variant: 'success',
                    });
                }
            )
        );
    };

    render() {
        const { new_iccid, entity, tariffs, showAccept, simCard } = this.state;
        return (
            <Card>
                <CardBody>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Typography variant="subtitle1">
                                <I18n trans="simcard:edit.change_iccid" />
                            </Typography>
                        </GridItem>
                        {simCard.eSimOnChange && (
                            <>
                                <GridItem xs={6}>
                                    <Typography variant="subtitle2">
                                        <I18n trans="simcard:edit.change_to_esim_in_progres" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={12}>
                                    <ChangeButton
                                        callback={this.callChangeESIMButton}
                                        callbackParam={{}}
                                        label="simcard:edit.do_change_esim"
                                        size="sm"
                                    />
                                </GridItem>
                            </>
                        )}
                        {!simCard.eSimOnChange && (
                            <>
                                <GridItem xs={6}>
                                    <Typography variant="subtitle2">
                                        <I18n trans="simcard:edit.new_iccid_number" />
                                    </Typography>
                                </GridItem>
                                <GridItem xs={6}>
                                    <Typography variant="subtitle2">{new_iccid}</Typography>
                                </GridItem>
                                {/*<GridItem xs={12}>*/}
                                {/*    <TariffsRange*/}
                                {/*        callback={this.selectFunc}*/}
                                {/*        restElements={tariffs}*/}
                                {/*        stateName="tariffId"*/}
                                {/*        idState="tariffId"*/}
                                {/*        idSelected={entity.tariffId}*/}
                                {/*        propKey="id"*/}
                                {/*        required={false}*/}
                                {/*        propValue="tariffName"*/}
                                {/*        emptyLabel="general:common.empty_label"*/}
                                {/*        label="tariffs:t.tariff"*/}
                                {/*    />*/}
                                {/*</GridItem>*/}
                                <GridItem xs={12}>
                                    <ChangeButton callback={this.openGetIccid} callbackParam={{}} label="simcard:edit.choose_new_iccid" size="sm" />
                                    {showAccept === true && (
                                        <ChangeButton callback={this.callChangeButton} callbackParam={{}} label="simcard:edit.change" size="sm" />
                                    )}
                                </GridItem>
                                <IccidPoolChooseDialog
                                    platformResellerId={simCard.client ? simCard.client.platformResellerId : Auth.getUserPlatformResellerId()}
                                    callBackClose={this.closeIccid}
                                    callBackSetIccid={this.callBackSetIccid}
                                    open={this.state.openIccid}
                                    simCard={simCard}
                                />
                            </>
                        )}
                    </GridContainer>
                </CardBody>
            </Card>
        );
    }
}

SimCardChangeIccid.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    const { simCardReducers } = state;
    let tariffs = null;
    if (simCardReducers && simCardReducers.tariffs) {
        tariffs = simCardReducers.tariffs;
    }
    return {
        tariffs: tariffs,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(SimCardChangeIccid);
export default Enhance;
